import React, { useEffect, useContext, useState } from "react"
import { useReactOidc } from "@axa-fr/react-oidc-context"
import { JitsiMeeting } from "@jitsi/react-sdk"
import { IntlContext } from "@src/utility/context/Internationalization"
import { Card, CardBody } from "reactstrap"

const Jitsi = () => {
    const { oidcUser } = useReactOidc()
    const intlContext = useContext(IntlContext)
    const [roomName, setRoomName] = useState("")

    useEffect(() => {
        if (window.location.search) {
            const urlParams = new URLSearchParams(window.location.search)
            setRoomName(urlParams.get('roomName'))
        }
    }, [])

    const handleAPI = JitsiMeetAPI => {
        JitsiMeetAPI.executeCommand("toggleVideo")
    }

    return (
        <Card>
            <CardBody>
                {roomName && (
                    <JitsiMeeting
                        domain={`${process.env.REACT_APP_DOMAIN_JITSI}`}
                        roomName={`${roomName}`}
                        configOverwrite={{
                            defaultLanguage: `${intlContext.locale}`,
                            prejoinPageEnabled: false,
                            requireDisplayName: false
                        }}
                        interfaceConfigOverwrite={{
                            lang: `${intlContext.locale}`,
                            APP_NAME: "CyberID",
                            DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
                            HIDE_INVITE_MORE_HEADER: true,
                            MOBILE_APP_PROMO: false,
                            SHOW_CHROME_EXTENSION_BANNER: false
                        }}
                        userInfo={{
                            displayName: oidcUser?.profile?.name,
                            email: oidcUser?.profile?.email
                        }}
                        onApiReady={handleAPI}
                        getIFrameRef={(iframeRef) => { iframeRef.style.height = `${window.innerHeight - 225}px` }}
                    />
                )}
            </CardBody>
        </Card>
    )
}

export default Jitsi